// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__z2Uo-","left":"StickyBox_left__Fbq_o","right":"StickyBox_right__2Tn85"};